module.exports = __webpack_public_path__ + "static/img/gxg2.e8631b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxg2.png
// module id = JGKn
// module chunks = 2